/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'rotate-cw': {
    width: 16,
    height: 16,
    viewBox: '0 0 20.298 20.298',
    data: '<path pid="0" d="M19.347 11.102a.473.473 0 0 0-.475-.474h-2.421a.473.473 0 0 0-.475.474 5.835 5.835 0 0 1-5.827 5.826 5.835 5.835 0 0 1-5.827-5.826 5.832 5.832 0 0 1 6.843-5.737v1.647a.475.475 0 0 0 .812.335l4.832-3.273a.472.472 0 0 0 0-.667L11.976.139a.479.479 0 0 0-.519-.104.476.476 0 0 0-.291.438V1.96a9.159 9.159 0 0 0-1.016-.057C5.079 1.903.952 6.03.952 11.101c0 5.07 4.127 9.197 9.198 9.197 5.07.001 9.197-4.126 9.197-9.196z" _fill="#030104"/>'
  }
})
